import React from "react";
import { PenLine } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MyBlogsHero() {
  const navigate = useNavigate();
  return (
    <section className="w-full bg-[#FCFBFE] overflow-hidden">
      <div className=" flex flex-col md:flex-row items-center gap-10 md:gap-16">
        <div className="w-full md:w-[340px] shrink-0">
          <img
            src="/img/blog/loging.svg"
            alt="Your stories, your journey"
            className="w-full h-auto object-contain"
          />
        </div>

        <div className="flex-1 flex flex-col items-center text-center py-10 md:py-16">
          <h1 className="font-semibold text-3xl sm:text-4xl md:text-[40px] leading-tight mb-3">
            <span className="text-slate-900">Your </span>
            <span className="text-[#7209B7]">Stories, </span>
            <span className="text-slate-900">Your </span>
            <span className="text-[#7209B7]">Journey</span>
          </h1>
          <p className="text-slate-500 text-sm sm:text-base max-w-xl mb-8">
            Write about your adventures, inspire others, and keep all your
            travel stories organized.
          </p>
          <button
            type="button"
            onClick={() => navigate("/dashboard/create-blog")}
            className="inline-flex items-center gap-2 bg-[#7209B7] text-white font-semibold text-sm px-7 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200"
          >
            <PenLine className="w-4 h-4" />
            Write New Blog
          </button>
        </div>
      </div>
    </section>
  );
}
